export const downloadVendorOrderFilesAsync = (rootUrl: string) => (fileId: number) => {
	const url = new URL(`${rootUrl}/vendor-order/file?fileId=${fileId}`);
	return `${url}`;
};
